import { useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router';
import { useDefaultTab } from '@/features/auth/useDefaultTab';

/**
 * Rendered at route "/".
 * Canonical entry always redirects to the catalog surface.
 */
export function DefaultTabRedirect() {
  const { defaultTab, resolved } = useDefaultTab();
  const navigate = useNavigate();

  useEffect(() => {
    if (resolved) {
      void navigate(defaultTab, { replace: true });
    }
  }, [resolved, defaultTab, navigate]);

  // Immediate redirect while waiting — /catalog is always safe
  if (!resolved) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-white">
        <div className="w-6 h-6 border-2 border-blue-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return <Navigate to={defaultTab} replace />;
}
